import React, { Component } from 'react'
import styled from 'styled-components'

const Img = styled.img`
  width: 35%;
  margin: 1.1rem 1rem;
`

export default class Logo extends Component {
  render() {
    return <Img alt="" src="/images/logo-long.png" />
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/Logo.js